<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-group row">
        <div class="col-md-12">
            <yt-number-input-v3
                name="txtRedniBroj"                                 
                [Label]="'VELICINASTAV.REDNIBROJ.SINGULAR'" 
                formControlName="RedniBroj"
                [FormatString]="'1.0-0'"
            >
            </yt-number-input-v3>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-12">
            <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                #focusElement
                [MaxLength]="50"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'VELICINASTAV.NAZIV.SINGULAR'"
            >
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
</form>